module.exports = __webpack_public_path__ + "img/01.f950d309.png";